import { app } from '../../../app';
import { Controller } from './sp-pagination.controller';

app.component('spPagination', {
    bindings: {
        hasCustomItemsPerPage: '<?',
    },
    controller: Controller,
    require: {stTable: '^'},
    templateUrl: require('./sp-pagination.html')
});



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/pagination/sp-pagination.component.js